const validate = (values) => {
  const errors = {};
  if (values.evaluativeActivitiesGrid) {
    const { closingData } = values.evaluativeActivitiesGrid;
    if (closingData && closingData.length) {
      closingData.forEach((item) => {
        if (item.evaluations.length) {
          item.evaluations.forEach((evaluation) => {
            if (evaluation.evaluationId && !evaluation.correctionId) {
              errors.errors = `Corrija a avaliação ${evaluation.evaluationDateKey} ${evaluation.evaluationTitle} para o aluno ${item.studentName}`;
            }
          });
        }
      });
    }
  }
  return errors;
};
export default validate;
